import { ExchangeCode } from "@/lib/market-data/market-data.types";
import { ExchangeCandleRestAdapter } from "../../candle.types";
import { binanceCandlesRestAdapter } from "./binance-candles.rest";
import { bybitCandlesRestAdapter } from "./bybit-candles.rest";
import { hyperliquidCandlesRestAdapter } from "./hyperliquid-candles.rest";

export const BROWSER_DIRECT_CANDLE_REST_ADAPTERS: Partial<
  Record<ExchangeCode, ExchangeCandleRestAdapter>
> = {
  binance: binanceCandlesRestAdapter,
  bybit: bybitCandlesRestAdapter,
  hyperliquid: hyperliquidCandlesRestAdapter,
  asterdex: binanceCandlesRestAdapter,
};
